import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Pied de page de la surface publique — copie unique, partagée par la landing,
 * les pages fonctionnalités, les tarifs, le contact et les pages légales.
 *
 * La surface est celle du « rail » de l'application (`--color-bg-rail`), séparée
 * du corps par un filet. L'ancien pied de page était un `bg-gray-900` codé en
 * dur : un gris FROID, qui jurait avec les neutres chauds de Méridien et ne
 * bougeait pas d'un mode à l'autre.
 */
export default function PublicFooter() {
  const { t: tc } = useTranslation('common');

  const columns = [
    {
      title: tc('footer.features'),
      links: [
        { label: tc('footer.dashboard'), to: '/fonctionnalites/dashboard' },
        { label: tc('footer.operations'), to: '/fonctionnalites/operations' },
        { label: tc('footer.expenseSharing'), to: '/fonctionnalites/partage' },
        { label: tc('footer.budgets'), to: '/fonctionnalites/budgets' },
        { label: tc('nav.pricing'), to: '/tarifs' },
      ],
    },
    {
      title: tc('footer.legal'),
      links: [
        { label: tc('footer.legalNotice'), to: '/mentions-legales' },
        { label: tc('footer.privacyPolicy'), to: '/politique-confidentialite' },
        { label: tc('footer.terms'), to: '/conditions-utilisation' },
      ],
    },
  ];

  return (
    <footer className="pub-footer py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8">
          <div>
            <span className="pub-wordmark pub-footer-title text-xl font-bold">
              Splinity
              <span className="pub-subtle text-[10px] font-normal ml-1">
                ({__APP_STAGE__} v{__APP_VERSION__})
              </span>
            </span>
            <p className="mt-2 text-sm">{tc('footer.description')}</p>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h4 className="pub-footer-title font-semibold mb-4">{column.title}</h4>
              <ul className="space-y-2 text-sm">
                {column.links.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="pub-footer-title font-semibold mb-4">{tc('footer.contactTitle')}</h4>
            <ul className="space-y-2 text-sm">
              <li>contact@splinity.com</li>
              <li>
                <Link to="/contact">{tc('footer.contactForm')}</Link>
              </li>
            </ul>
            <h4 className="pub-footer-title font-semibold mt-6 mb-4">{tc('footer.application')}</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/login">{tc('footer.signIn')}</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t pub-rule text-center text-sm pub-subtle">
          <p>
            &copy; {new Date().getFullYear()} {tc('footer.allRightsReserved')}
          </p>
        </div>
      </div>
    </footer>
  );
}
